import map from 'lodash/map'
import $ from 'jquery'
import Vue from 'vue'
import 'slick-carousel'
// eslint-disable-next-line import/no-unresolved
import PhotoSwipe from '@PhotoSwipe'
import Swiper, { Navigation } from 'swiper'

import '../../../scss/app/product.scss'

//
// Wishlist
//

const wishlistEl = document.querySelector('.js-wishlist-entry')
if (wishlistEl) {
  const WishlistButton = {
    template: `
      <button type="button" class="primary button" @click="toggle">{{ caption }}</button>
    `,
    props: {
      inWishlist: {
        type: Boolean,
        default: false,
      },
      toggleUrl: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        realInWishlist: this.inWishlist,
      }
    },
    computed: {
      caption() {
        return this.realInWishlist ? 'Remove from Wish List' : 'Add to Wish List'
      },
    },
    methods: {
      toggle() {
        if (this.xhr) {
          this.xhr.abort()
        }

        this.xhr = $.ajax({
          type: 'POST',
          url: this.toggleUrl,
          dataType: 'json',
        }).done((resp) => {
          this.realInWishlist = resp.inWishlist
        })
      },
    },
    created() {
      this.xhr = null
    },
  }

  new Vue({
    el: wishlistEl,
    components: {
      WishlistButton,
    },
  })
}

//
// Photos
//

const mainImageContainer = document.querySelector('.main-image')

if (mainImageContainer) {
  const photos = map(window.APP.productPhotos, (photo) => ({
    src: window.APP.context.site.files_url + photo.path,
    w: photo.width,
    h: photo.height,
  }))

  const $bigSlides = $('.big-slides')
  const $thumbButtons = $('.thumb-button')

  if ($bigSlides.length) {
    $bigSlides.slick({
      infinite: true,
      lazyLoad: 'progressive',
      adaptiveHeight: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      rows: 0,
      arrows: false,
      dots: false,
    })

    $bigSlides.on('click', '.slide', (ev) => {
      ev.preventDefault()
      const gallery = new PhotoSwipe({
        index: $(ev.currentTarget).closest('.slick-slide').data('slick-index'),
        bgOpacity: 1,
        dataSource: photos,
      })
      gallery.init()
    })

    $bigSlides.on('beforeChange', (ev, slick, currentSlide, nextSlide) => {
      $thumbButtons.removeClass('--is-active').eq(nextSlide).addClass('--is-active')
    })

    if (photos.length > 1) {
      $thumbButtons.on('click', (ev) => {
        ev.preventDefault()
        $thumbButtons.removeClass('--is-active')
        const $button = $(ev.currentTarget)
        const photoIdx = parseInt($button.data('idx'), 10)
        $bigSlides.slick('slickGoTo', photoIdx)
        $button.addClass('--is-active')
      })
    }
  }
}

//
// Room Scenes
//

document.querySelectorAll('.room-scene').forEach((sceneEl) => {
  const swiperEl = sceneEl.querySelector('.swiper')
  const prevEl = sceneEl.querySelector('.swiper-button-prev')
  const nextEl = sceneEl.querySelector('.swiper-button-next')
  const carousel = new Swiper(swiperEl, {
    modules: [Navigation],
    autoHeight: true,
    loop: true,
    navigation: { enabled: true, nextEl, prevEl },
  })
})
